"use client";

import React from "react";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import styles from "./footer.module.css";

const FOOTER_LINKS = [
  {
    title: "Buy",
    links: [
      { label: "Apartments", href: "/search?type=apartments" },
      { label: "Villas", href: "/search?type=villas" },
      { label: "Luxury Homes", href: "/search?type=luxury" },
      { label: "New Developments", href: "/search?type=developments" },
    ],
  },
  {
    title: "Rent",
    links: [
      { label: "Apartments", href: "/rent?type=apartments" },
      { label: "Houses", href: "/rent?type=houses" },
      { label: "Short Term", href: "/rent?type=short-term" },
      { label: "Long Term", href: "/rent?type=long-term" },
    ],
  },
  {
    title: "Invest",
    links: [
      { label: "Opportunities", href: "/invest/opportunities" },
      { label: "Commercial", href: "/search?type=commercial" },
      { label: "Land", href: "/search?type=land" },
      { label: "Market Insights", href: "/insights" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Guides", href: "/guides" },
      { label: "News", href: "/news" },
      { label: "About Real Estate", href: "/about-real-estate" },
      { label: "Help Center", href: "/help" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Press", href: "/press" },
      { label: "Contact Us", href: "/contact" },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* --- TOP SECTION --- */}
        <div className={styles.topSection}>
          {/* Brand Column */}
          <div className={styles.brandColumn}>
            {/* Replace with your actual logo SVG/Image */}
            <Link href="/" className={styles.logoLink} aria-label="Doomum Home">
              <h2 className={styles.logoText}>doomum.com</h2>
            </Link>
            <p className={styles.tagline}>
              The world&apos;s properties.
              <br />
              One place to call home.
            </p>
            <p className={styles.copyright}>
              © {currentYear} Doomum. All rights reserved.
            </p>

            <div className={styles.socials}>
              <a href="#" aria-label="Facebook" className={styles.socialLink}>
                <FaFacebookF />
              </a>
              <a href="#" aria-label="Instagram" className={styles.socialLink}>
                <FaInstagram />
              </a>
              <a href="#" aria-label="LinkedIn" className={styles.socialLink}>
                <FaLinkedinIn />
              </a>
              <a href="#" aria-label="YouTube" className={styles.socialLink}>
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div className={styles.linksGrid}>
            {FOOTER_LINKS.map((col, index) => (
              <div key={index} className={styles.linkColumn}>
                <h4 className={styles.columnTitle}>{col.title}</h4>
                <ul className={styles.linkList}>
                  {col.links.map((link, idx) => (
                    <li key={idx}>
                      <Link href={link.href} className={styles.linkItem}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* --- BOTTOM SECTION --- */}
        <div className={styles.bottomSection}>
          <div className={styles.legalLinks}>
            <Link href="/terms" className={styles.bottomLink}>
              Terms of Use
            </Link>
            <Link href="/privacy" className={styles.bottomLink}>
              Privacy Policy
            </Link>
            <Link href="/cookies" className={styles.bottomLink}>
              Cookie Policy
            </Link>
            <Link href="/sitemap" className={styles.bottomLink}>
              Sitemap
            </Link>
          </div>

          {/* <div className={styles.preferences}>
            <button className={styles.prefButton}>
              English <MdKeyboardArrowDown />
            </button>
            <button className={styles.prefButton}>
              EUR <MdKeyboardArrowDown />
            </button>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
